/*
 * @author: xd
 * @Date: 2021-12-15 12:59:53
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:21:07
 * @Description: 功能
 */

import { Axios } from "../../utils/Axios";
import { BaseClass } from "../../base/DreamScape";
import { Cache } from "../../utils/cache";
export interface IUserLoginParameter {
  XDLMSID: string;
  XDLMCID: string;
  XDLMTID: string;
  XDLMmLoginName?: string;
  XDLMPassword?: string;
  XDLMPhoneNum?: string;
  XDLMCaptcha?: string;
}
export class Login extends BaseClass {
  axios: Axios;
  private _appid: string;
  private _pid: string;
  private _url: string;
  constructor(pro: any) {
    super();
    this.axios = new Axios();
    this._url = pro.url;
    this._pid = pro.pid;
    this._appid = pro.appid;
  }

  login(sid: string, username: string, password: string): Promise<any> {
    let loginInfo: IUserLoginParameter = {
      XDLMSID: sid,
      XDLMCID: "7000",
      XDLMTID: "7001",
      XDLMmLoginName: username,
      XDLMPassword: password,
    };
    return this.mlogin(this._url, this._pid, this._appid, loginInfo, 0);
    // .then((result) => {
    //   console.log(result);
    // },(err)=>{

    //     console.log(err)

    // });
  }
  loginByPhone(sid: string, username: string, password: string): any {
    let loginInfo: IUserLoginParameter = {
      XDLMSID: sid,
      XDLMCID: "7000",
      XDLMTID: "7016",
      XDLMPhoneNum: username,
      XDLMCaptcha: password,
    };
    return this.mlogin(this._url, this._pid, this._appid, loginInfo, 1);
  }
  /**
   * @description: 用户登录
   * @param {*}
   * @return {*}
   */
  private mlogin(mUrl: string, dataName: string, appid: string, loginParameter: IUserLoginParameter, type: number): Promise<any> {
    // if (type == 0) {
    //   return  http.PostDataByID(dataName,"GetDataInterface", loginParameter, appid);
    // } else {
    return this.axios.PostDataByID(mUrl, dataName, "GetDataInterface", loginParameter, appid);
    // }
    // if (returnData.then.success) {
    //   Cache.SetCookie("sytoken", returnData.sytoken, "h8");
    // }

  }
  //注销用户
  loginOut(): void {
    Cache.DelCookie("mUserName");
    Cache.DelCookie("xmbh");
    Cache.DelCookie("sytoken");
    Cache.DelCookie("mUserID");
  }
}
